var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9786_1754",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9786_1754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.14429 10.6247L10.452 14.9325C10.5759 15.0564 10.6371 15.2014 10.6355 15.3675C10.6339 15.5337 10.5684 15.6814 10.4392 15.8106C10.3099 15.9314 10.1635 15.9939 10.0001 15.9981C9.83663 16.0024 9.69026 15.9399 9.561 15.8106L4.27735 10.527C4.19937 10.449 4.14435 10.3667 4.11229 10.2802C4.08024 10.1937 4.06421 10.1002 4.06421 9.99976C4.06421 9.89933 4.08024 9.80585 4.11229 9.71933C4.14435 9.63278 4.19937 9.55052 4.27735 9.47253L9.561 4.18889C9.67638 4.0735 9.81926 4.01447 9.98967 4.01181C10.1601 4.00914 10.3099 4.06817 10.4392 4.18889C10.5684 4.31815 10.6331 4.46665 10.6331 4.63439C10.6331 4.80212 10.5684 4.95062 10.4392 5.07989L6.14429 9.37478H15.6251C15.8024 9.37478 15.9509 9.43461 16.0706 9.55426C16.1902 9.67392 16.2501 9.82242 16.2501 9.99976C16.2501 10.1771 16.1902 10.3256 16.0706 10.4453C15.9509 10.5649 15.8024 10.6247 15.6251 10.6247H6.14429Z",
    fill: "#8E969C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowback);
export default __webpack_public_path__ + "static/media/arrowback.7d84ec8712b0b3c41dcbbd8e93acd9fd.svg";
export { ForwardRef as ReactComponent };